import React from 'react';

const FlightIcon = () => {
  return (
    <svg
      stroke="#222222"
      fill="#222222"
      strokeWidth="0"
      viewBox="0 0 24 24"
      height="20px"
      width="20px"
    >
      <path fill="none" d="M0 0h24v24H0z"></path>
      <path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"></path>
    </svg>
  );
};

export default FlightIcon;
